import React from 'react';
import { cn } from '../../lib/utils';
interface SectionProps extends React.HTMLAttributes<HTMLElement> {
  children: React.ReactNode;
  variant?: 'default' | 'light' | 'dark';
}
export function Section({
  children,
  className,
  variant = 'default',
  ...props
}: SectionProps) {
  const variants = {
    default: 'bg-dashboard-bg text-dashboard-text',
    light: 'bg-dashboard-surface text-dashboard-text',
    dark: 'bg-dashboard-bg text-dashboard-text'
  };
  return <section className={cn('py-16 md:py-24 lg:py-28', variants[variant], className)} {...props} data-id="element-405">
      {children}
    </section>;
}